function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString();
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

document.addEventListener('DOMContentLoaded', function() {
  const formSection = document.getElementById('formulario');
  const hasVoted = getCookie('aguasclaras_voted');
  
  if (hasVoted) {
      formSection.style.display = 'none';
      const thankYouMessage = document.createElement('div');
      thankYouMessage.className = 'container text-center obrigado';
      thankYouMessage.innerHTML = '<h3>Obrigado por participar da votação! <br> Aguarde o resultado!</h3>';
      formSection.parentNode.insertBefore(thankYouMessage, formSection);
  }
});

// Add this to your form submission success callback
function onFormSuccess() {
  setCookie('aguasclaras_voted', 'true', 365); // Cookie válido por 1 ano
  window.location.reload();
}



$(document).ready(function() {
  // your code
  var window = $(window);

  $('#nav-icon2').click(function(){
	
    var target = $(this).data('alvo');
    

    if (!$(this).hasClass('open')){
      $(".arrow").addClass('d-none');
    $(target).animate({
      left:'30px',
    },function(){
          $("#nav-icon2").toggleClass('abrir');	
        })
    }
    else{
      $(target).animate({
      left:'-250px',
    },function(){
          $("#nav-icon2").toggleClass('abrir');	
          $(".arrow").removeClass('d-none');
        })
    }
    $(this).toggleClass('open');
  });


  $("body").on('click','.btnClose',function(e){
    e.preventDefault();
    $(".modalSuccess").removeClass('active')
    })
    var window = $(window);
    $(".formSubmit").submit(function(e) {
      $(".formSubmit .btnSubmit").attr('disabled',true)
              e.preventDefault();
              $(".loading").addClass('active');
              var url = "enviar.php"; // the script where you handle the form input.
              if(
                $(this).find('input[name="nome"]').val() == "" && 
                $(this).find('input[name="telefone"]').val() == "" &&  
                $(this).find('input[name="email"]').val() == ""){
                  alert("Atenção, Todos os campos são obrigatórios.")
              }
              $.ajax({
                     type: "POST",
                     url: url,
                     data: $(this).serialize(), // serializes the form's elements.
                     success: function(data)
                     {
                      $(".loading").removeClass('active');
                       console.log(data)
                       var json = JSON.parse(data);
                       console.log(json)
                        if(json.status == "error"){
                          swal({
                            title: "Atenção",
                            text: json.message,
                            icon: "error"
                          });
                        }
                        if(json.status == "success" || json.status == "error_envio"){
                          swal({
                            title: "Parabéns",
                            text: json.message,
                            icon: "success"
                          });
                          $(".formSubmit")[0].reset();
                          $(".formSubmit").html(`
                            <h2>Votação realizada com sucesso! <br> Aguarde o resultado...</h2>`)
                         
                        }
                        $(".formSubmit .btnSubmit").attr('disabled',false)
                     },error:function(data){
                console.log(data)
                $(".loading").removeClass('active');
                alert("Erro ao envior e-mail, por favor tente mais tarde")
                 }
                   });
  
              e.preventDefault(); // avoid to execute the actual submit of the form.
          });
  
})